export type AppThemeName = 'BLUE' | 'BLACK_WHITE';

const THEME_STORAGE_KEY = 'alertai_theme';

// Valores do tema BLUE são exatamente os hex que já existiam hardcoded no sistema — zero mudança
// visual pra quem já usa o padrão. BLACK_WHITE é o novo tema: preto como cor principal, branco
// como cor de detalhe/destaque (troca o azul de acento por branco).
// Exportado (read-only) pra telas que precisam mostrar um preview de cada tema com cores literais,
// já que CSS vars só refletem o tema atualmente aplicado — não dá pra usar var() pra comparar os dois.
export const THEME_PREVIEW_COLORS: Record<AppThemeName, Record<string, string>> = {
  BLUE: {
    '--app-bg': '#0b1220',
    '--app-surface-1': '#1a2035',
    '--app-surface-2': '#202940',
    '--app-surface-header': '#171f2f',
    '--app-table-border': '#2F3957FF',
    '--app-text': '#ffffff',
    '--app-divider': 'gray',
    '--app-accent': '#1976d2',
    '--app-accent-bg': 'rgba(25, 118, 210, 0.14)',
    '--app-accent-muted': '#2F4D80',
    '--app-hero-gradient-1': 'rgb(34, 53, 100)',
    '--app-hero-gradient-2': 'rgb(35, 43, 63)',
  },
  BLACK_WHITE: {
    '--app-bg': '#000000',
    '--app-surface-1': '#0d0d0d',
    '--app-surface-2': '#141414',
    '--app-surface-header': '#000000',
    '--app-table-border': 'rgba(255, 255, 255, 0.2)',
    '--app-text': '#ffffff',
    '--app-divider': 'rgba(255, 255, 255, 0.3)',
    '--app-accent': '#ffffff',
    '--app-accent-bg': 'rgba(255, 255, 255, 0.12)',
    '--app-accent-muted': 'rgba(255, 255, 255, 0.55)',
    '--app-hero-gradient-1': '#2b2b2b',
    '--app-hero-gradient-2': '#161616',
  },
};

export const getStoredTheme = (): AppThemeName => {
  if (typeof window === 'undefined') return 'BLUE';
  const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
  return stored === 'BLACK_WHITE' ? 'BLACK_WHITE' : 'BLUE';
};

// Aplica as CSS variables no :root e guarda a preferência localmente (pra repintar instantâneo
// na próxima visita, antes da preferência real da licença voltar do backend).
export const applyThemeVars = (theme: AppThemeName) => {
  if (typeof document === 'undefined') return;
  const vars = THEME_PREVIEW_COLORS[theme] ?? THEME_PREVIEW_COLORS.BLUE;
  Object.entries(vars).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
  window.localStorage.setItem(THEME_STORAGE_KEY, theme);
};

// Roda assim que este módulo é importado (antes do primeiro render do React) pra já pintar com o
// tema salvo e evitar o "flash" do tema padrão antes do React montar.
applyThemeVars(getStoredTheme());

export const backgroundColorDarkTheme = 'var(--app-bg)';
export const fontColorDarkTheme = 'var(--app-text)';
export const borderColorDarkTheme = 'var(--app-divider)';
export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  backgroundColor: backgroundColorDarkTheme,
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxWidth: '90vw',
  maxHeight: '80vh',
  overflow: 'auto',
  boxShadow: 24,
  p: 4,
  pt: 0,
};
